import React, {useEffect, useRef, useState} from 'react';
import AudioPlayer from 'react-h5-audio-player';
import {getPublicImagePath, getUploadedImagePath, useBreakpoints} from '@nutastic/nutastic-react-app';
import ReactPlayer from "react-player/youtube";
import {PauseCircleFilled, PlayCircleFilled} from "@ant-design/icons";
import useWindowSize from "../hooks/useWindowSize";

const convertSecondsToTime = (v) => {
    var sec_num = parseInt(v, 10); // don't forget the second param
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    return hours > 0 ? hours+':'+minutes+':'+seconds : minutes+':'+seconds;
};

const componentClass = 'youtubeVideoPlayer';

const YoutubeVideoPlayer = ({ videoUrl }) => {
    const { xl: isXtraLargeScreen } = useBreakpoints();
    const { windowWidth } = useWindowSize();
    const [isPlaying, setIsPlaying] = useState(false);
    const [isSeeking, setIsSeeking] = useState(false);
    const [progress, setProgress] = useState(null);
    const [durationInSeconds, setDurationInSeconds] = useState(0);
    const videoPlayerRef = useRef(null);

    const videoWidth = isXtraLargeScreen ? 1280 : windowWidth-20;
    const videoHeight = isXtraLargeScreen ? 720 : (videoWidth / (16/9));

    const handleSeekMouseDown = e => {
        setIsSeeking(true);
    };

    const handleSeekMouseUp = e => {
        setIsSeeking(false);
        videoPlayerRef && videoPlayerRef.current.seekTo(parseFloat(e.target.value));
    };

    const handleSeekChange = e => {
        setProgress({
            ...progress,
            played: parseFloat(e.target.value)
        });
    };

    return <div className={componentClass}>
        <ReactPlayer
            ref={videoPlayerRef}
            url={videoUrl}
            width={videoWidth}
            height={videoHeight}
            className={`${componentClass}__video`}
            playing={isPlaying}
            onPlay={() => setIsPlaying(true)}
            onProgress={v => !isSeeking && setProgress(v)}
            onDuration={v => setDurationInSeconds(v)}
            config={{
                youtube: {
                    playerVars: { showinfo: 1 }
                }
            }}
        />
        <div className={`${componentClass}__videoControls`}>
            <button onClick={() => setIsPlaying((p) => !p)}>
                { isPlaying ? <PauseCircleFilled /> : <PlayCircleFilled /> }
            </button>
            <div className="videoProgress">
                { progress && <span>{ convertSecondsToTime(progress.playedSeconds) }</span> }
                <input
                    type='range'
                    min={0}
                    max={0.999999}
                    step='any'
                    value={progress?.played || 0}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                />
                { durationInSeconds && <span>{ convertSecondsToTime(durationInSeconds) }</span> }
            </div>
        </div>
    </div>;
};

export default YoutubeVideoPlayer;
